const mainHeader = document.querySelector<HTMLElement>('.main-header');
let lastScrollTop = window.scrollY || document.documentElement.scrollTop;
window.addEventListener('scroll', () => {
  const st = document.documentElement.scrollTop;
  if(st < mainHeader.offsetHeight + 128) return;
  if (st > lastScrollTop) {
    mainHeader?.classList.add('--scrolled')
  } else if (st < lastScrollTop) {
    mainHeader?.classList.remove('--scrolled')
  }
  lastScrollTop = st <= 0 ? 0 : st;
}, {passive: true})
